import './StoreIcons.css';

/**
 * Brand icons for app store download badges.
 * Simplified vector marks - Google Play's colorful play triangle
 * and the Apple logo.
 */

function GooglePlayIcon() {
  return (
    <svg
      className="store-icon"
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3.6 1.8 13.7 12 3.6 22.2c-.37-.2-.6-.6-.6-1.1V2.9c0-.5.23-.9.6-1.1z" fill="#00C4FF" />
      <path d="M17.4 8.4 13.7 12 3.6 1.8c.22-.13.5-.14.76.02l13.04 6.58z" fill="#00E676" />
      <path d="M17.4 15.6 4.36 22.2c-.26.16-.54.15-.76.02L13.7 12l3.7 3.6z" fill="#FF3D00" />
      <path d="M17.4 8.4 21 10.2c.9.46.9 1.7 0 2.16l-3.6 1.8L13.7 12l3.7-3.6z" fill="#FFC400" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg
      className="store-icon"
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M16.36 12.7c.02 2.63 2.3 3.5 2.33 3.51-.02.06-.37 1.25-1.21 2.47-.73 1.06-1.49 2.11-2.68 2.13-1.17.02-1.55-.69-2.89-.69-1.34 0-1.75.67-2.86.71-1.15.04-2.02-1.14-2.75-2.2-1.5-2.17-2.64-6.14-1.1-8.82.77-1.33 2.14-2.17 3.63-2.19 1.13-.02 2.19.76 2.89.76.69 0 1.99-.94 3.36-.8.57.02 2.18.21 3.21 1.66-.08.05-1.92 1.12-1.9 3.34l-.03.32zM14.3 4.6c.61-.74 1.02-1.77.91-2.79-.88.04-1.95.59-2.59 1.33-.57.65-1.06 1.7-.93 2.7.98.08 1.99-.5 2.61-1.24z"
        fill="currentColor"
      />
    </svg>
  );
}

export { GooglePlayIcon, AppleIcon };
